<template>
    <div id="home">
        <div style="width: 100%">
            <el-row style="height: 52px;background: #fff;width: 100%;">
                <el-col :span="12">
                    <div class="block" style="line-height: 52px;margin-left: 10px;">
                        <span class="demonstration">年月</span>
                        <el-date-picker
                                v-model="date"
                                format="yyyy年M月"
                                value-format="yyyy-MM"
                                type="month"
                                @change="changeDate"
                                placeholder="选择月">
                        </el-date-picker>
                    </div>
                </el-col>
                <el-col :span="12">
                    <div style="float: right;line-height: 50px;margin-right: 10px;">
                        <span style="font-size: 16px;font-weight: bold;margin-right: 10px;">辖区</span>
                        <homepopedom :handleSelectInput="handleSelectInputClick" ></homepopedom>
                    </div>
                </el-col>
            </el-row>
        </div>

        <div style="width: 100%;margin-top:10px;flex-wrap: nowrap;display: flex">
            <div style="width: calc(25% - 7px);background: #fff;height: 220px;margin-right: 10px">
                <el-row style="height: 30px;margin-top:10px;">
                    <el-col  style="background: #4BBFEF;height: 30px;width: 15px;">
                    </el-col>

                    <el-col :span="20" style="margin-left: 15px">
                        <p style="margin:0;line-height: 30px">
                            目标客户
                        </p>
                    </el-col>
                </el-row>
                <div style="width: 90%;height: 160px;flex-wrap: wrap;display: flex;margin-left: 5%">
                    <div style="width: 50%;height: 80px;border-right: 1px solid #D8D8D8;border-bottom: 1px solid #D8D8D8;position: relative">
                        <p style="margin:0;font-size: 48px;color: #4BBFEF;height: 80px;line-height: 80px;text-align: center">
                            {{accountObj.institutions_num}}
                        </p>
                        <p style="margin:0;font-size: 16px;color: #4BBFEF;position: absolute; bottom: 5px;right:5px;">
                            机构
                        </p>
                    </div>
                    <div style="width: calc(50% - 1px);height: 80px;border-bottom: 1px solid #D8D8D8;position: relative">
                        <p style="margin:0;font-size: 48px;color: #FA541C;height: 80px;line-height: 80px;text-align: center">
                            {{accountObj.hcp_num}}
                        </p>
                        <p style="margin:0;font-size: 16px;color: #FA541C;position: absolute; bottom: 5px;left:5px;">
                            HCP
                        </p>
                    </div>
                    <div style="width: 50%;height: 80px;border-right: 1px solid #D8D8D8;position: relative">
                        <p style="margin:0;font-size: 48px;color: #FF9901;height: 80px;line-height: 80px;text-align: center">
                            {{accountObj.store_num}}
                        </p>
                        <p style="margin:0;font-size: 16px;color: #FF9901;position: absolute; top: 5px;right:5px;">
                            门店
                        </p>
                    </div>
                    <div style="width: calc(50% - 1px);height: 80px;position: relative">
                        <p style="margin:0;font-size: 48px;color: #60C8BD;height: 80px;line-height: 80px;text-align: center">
                            {{accountObj.distributor_num}}
                        </p>
                        <p style="margin:0;font-size: 16px;color: #60C8BD;position: absolute; top: 5px;left:5px;">
                            经销商
                        </p>
                    </div>
                </div>
            </div>
            <div style="width: calc(25% - 7px);background: #fff;height: 220px;margin-right: 10px">
                <el-row style="height: 30px;margin-top:10px;">
                    <el-col  style="background: #4BBFEF;height: 30px;width: 15px;">
                    </el-col>
                    <el-col :span="20" style="margin-left: 15px">
                        <p style="margin:0;line-height: 30px">
                            客户覆盖
                        </p>
                    </el-col>
                </el-row>
                <div style="width: 90%;height: 160px;margin-left: 5%">
                    <el-row  style="height: 20px;width: 100%;margin-top:10px" class="ins">
                        <el-col :span="7" style="height: 20px;font-size: 16px;color: #4BBFEF;line-height: 20px;">
                            机构覆盖
                        </el-col>
                        <el-col :span="17" style="height: 20px">
                            <el-progress :percentage="customersCoveredObj.institutions_covered" style="height: 20px"></el-progress>
                        </el-col>
                        <p style="margin:0;font-size: 10px;line-height: 10px;color: #A0AFB7;margin-left: 68%;">较上月
                            <img v-if="customersCoveredObj.institutions_type == 'rose'" src="../../../src/assets/images/Triangle_gree.png" />
                            <img v-if="customersCoveredObj.institutions_type == 'fall'" src="../../../src/assets/images/Triangle.png" />
                            <span v-if="customersCoveredObj.institutions_type_num>0" style="color: #D0021B">{{customersCoveredObj.institutions_type_num}}家</span>
                            <span v-else>-</span>
                        </p>
                    </el-row>
                    <el-row  style="height: 20px;width: 100%;margin-top:20px" id="hcp">
                        <el-col :span="7" style="height: 20px;font-size: 16px;color: #FA541C;line-height: 20px;">
                            HCP覆盖
                        </el-col>
                        <el-col :span="17" style="height: 20px">
                            <el-progress :percentage="customersCoveredObj.hcp_covered" style="height: 20px"></el-progress>
                        </el-col>
                        <p style="margin:0;font-size: 10px;line-height: 10px;color: #A0AFB7;margin-left: 68%;">较上月
                            <img v-if="customersCoveredObj.hcp_type == 'rose'" src="../../../src/assets/images/Triangle_gree.png" />
                            <img v-if="customersCoveredObj.hcp_type == 'fall'" src="../../../src/assets/images/Triangle.png" />
                            <span v-if="customersCoveredObj.hcp_type_num>0" style="color: #D0021B">{{customersCoveredObj.hcp_type_num}}家</span>
                            <span v-else>-</span>
                        </p>
                    </el-row>
                    <el-row  style="height: 20px;width: 100%;margin-top:20px" id="store">
                        <el-col :span="7" style="height: 20px;font-size: 16px;color: #FF9901;line-height: 20px;">
                            门店覆盖
                        </el-col>
                        <el-col :span="17" style="height: 20px">
                            <el-progress :percentage="customersCoveredObj.store_covered" style="height: 20px"></el-progress>
                        </el-col>
                        <p style="margin:0;font-size: 10px;line-height: 10px;color: #A0AFB7;margin-left: 68%;">较上月
                            <img v-if="customersCoveredObj.store_type == 'rose'" src="../../../src/assets/images/Triangle_gree.png" />
                            <img v-if="customersCoveredObj.store_type == 'fall'" src="../../../src/assets/images/Triangle.png" />
                            <span v-if="customersCoveredObj.store_type_num>0" style="color: #D0021B">{{customersCoveredObj.store_type_num}}家</span>
                            <span v-else>-</span>
                        </p>
                    </el-row>
                    <el-row  style="height: 20px;width: 100%;margin-top:20px" class="dis">
                        <el-col :span="7" style="height: 20px;font-size: 16px;color: #60C8BD;line-height: 20px;">
                            经销商覆盖
                        </el-col>
                        <el-col :span="17" style="height: 20px">
                            <el-progress :percentage="customersCoveredObj.distributor_covered" style="height: 20px"></el-progress>
                        </el-col>
                        <p style="margin:0;font-size: 10px;line-height: 10px;color: #A0AFB7;margin-left: 68%;">较上月
                            <img v-if="customersCoveredObj.distributor_type == 'rose'" src="../../../src/assets/images/Triangle_gree.png" />
                            <img v-if="customersCoveredObj.distributor_type == 'fall'" src="../../../src/assets/images/Triangle.png" />
                            <span v-if="customersCoveredObj.distributor_type_num>0" style="color: #D0021B">{{customersCoveredObj.distributor_type_num}}家</span>
                            <span v-else>-</span>
                        </p>
                    </el-row>
                </div>
            </div>
            <div style="width: calc(25% - 7px);background: #fff;height: 220px;margin-right: 10px">
                <el-row style="height: 30px;margin-top:10px;">
                    <el-col  style="background: #4BBFEF;height: 30px;width: 15px;">
                    </el-col>
                    <el-col :span="20" style="margin-left: 15px">
                        <p style="margin:0;line-height: 30px">
                            协访情况
                        </p>
                    </el-col>
                </el-row>
                <div style="width: 90%;height: 160px;margin-left: 5%">
                    <el-row style="margin-top:30px;">
                        <el-col :span="18">
                            <el-row style="margin-top:20px;" id="plan">
                                <el-col :span="7" style="font-size: 15px;color: #FF9901;">
                                    计划协访
                                </el-col>
                                <el-col :span="1" style="height: 20px"></el-col>
                                <el-col :span="12">
                                    <el-progress :percentage="100" style="margin-top:5px" :show-text="false"></el-progress>
                                </el-col>
                                <el-col :span="1" style="height: 20px"></el-col>
                                <el-col :span="3" style="color: #FF9901;font-size: 12px;line-height: 20px">
                                    {{coachInfo.coach_plan}}次
                                </el-col>
                            </el-row>
                            <el-row style="margin-top:20px;" id="real">
                                <el-col :span="7" style="font-size: 15px;color: #4BBFEF;">
                                    实际协访
                                </el-col>
                                <el-col :span="1" style="height: 20px"></el-col>
                                <el-col :span="12">
                                    <el-progress :percentage="coachInfo.plan_completion" style="margin-top:5px" :show-text="false"></el-progress>
                                </el-col>
                                <el-col :span="1" style="height: 20px"></el-col>
                                <el-col :span="3" style="color: #4BBFEF;font-size: 12px;line-height: 20px">
                                    {{coachInfo.record_num}}次
                                </el-col>
                                <p style="margin:0;font-size: 8px;color: #A0AFB7;margin-left: 35%">计划内{{coachInfo.plan_num}}次，计划外{{coachInfo.unplanned_num}}次</p>
                            </el-row>
                        </el-col>
<!--                        <el-col :span="1" style="height: 20px;"></el-col>-->
                        <el-col :span="6" class="complete">
                            <el-progress type="circle" :percentage="coachInfo.plan_completion" style="height: 80px;width: 100%"></el-progress>
                            <p style="margin:10px;font-size:12px;color: #60C8BD;text-align: center;width: 100%;display: flex;flex-wrap: nowrap;">计划完成率</p>
                        </el-col>
                    </el-row>
                </div>
            </div>
            <div style="width: calc(25% - 7px);background: #fff;height: 220px">
                <el-row style="height: 30px;margin-top:10px;">
                    <el-col style="background: #4BBFEF;height: 30px;width: 15px;">
                    </el-col>

                    <el-col :span="7" style="margin-left: 15px">
                        <p style="margin:0;line-height: 30px">
                            会议分布
                        </p>
                    </el-col>
                    <el-col :span="13">
                        <p style="margin:0;line-height: 40px;color: #4BBFEF">
                            会议总场次
                            <span style="border:1px solid #FF9901;background-color: #FF9901;border-radius: 5px;padding: 0 5px;color: #fff;text-align: center">
                                {{meettingArray.meet_sum}}
                            </span>
                            &nbsp;场
                        </p>
                    </el-col>
                </el-row>
                <div style="width: 90%;height: 160px;margin-left: 5%">
                    <div id="meeting" style="width:100%;height:100%;"></div>
                </div>
            </div>
        </div>

        <div style="width: 100%;margin-top:10px;background: #fff;height: 500px;">
            <el-row style="height: 30px;margin-top:10px;float:left;">
                <el-col  style="background: #4BBFEF;height: 30px;width: 15px;">
                </el-col>
                <el-col :span="20" style="margin-left: 30px;float: none">
                    <p style="margin:0;line-height: 30px">
                        签到看板
                    </p>
                </el-col>
            </el-row>
            <el-row style="height: 464px;width: 100%;padding: 50px 20px 20px">
                <el-col :span="10" style="height: 100%">
                    <div id="chinaMap" style="width: 100%;height: 100%">

                    </div>
                </el-col>
                <el-col :span="1" style="height: 100%"></el-col>
                <el-col :span="13">
                    <el-row>
                        <el-col style="width: 30%;background: #ffd79a;margin-right:5%;height: 149px;border-radius: 10px;">
                            <p style="margin:0;font-size:22px;color: #FF9901; height: 40px;text-align: center;margin-top:20px;">
                                <img src="../../assets/images/sunrise.png" style="display: inline-block;position: relative;top:8px;" />
                                <span style="line-height: 40px;height: 40px;">
                                    最早签入时间
                                </span>
                            </p>
                            <p style="margin:0;font-size:30px;color: #FF9901;height: 36px;line-height: 36px;text-align: center;margin-top:20px; ">
                                {{checkinArray.checkin_time}}
                            </p>
                        </el-col>
                        <el-col style="width: 30%;background: #b8e6f9;margin-right:5%;height: 149px;border-radius: 10px;">
                            <p style="margin:0;font-size:22px;color: #4BBFEF; height: 40px;text-align: center;margin-top:20px;">
                                <img src="../../assets/images/evening.png" style="display: inline-block;position: relative;top:8px;" />
                                <span style="line-height: 40px;height: 40px;">
                                    最晚签入时间
                                </span>
                            </p>
                            <p style="margin:0;font-size:30px;color: #4BBFEF;height: 36px;line-height: 36px;text-align: center;margin-top:20px; ">
                                {{checkinArray.checkout_time}}
                            </p>
                        </el-col>
                        <el-col style="width: 30%;background: #c0e9e5;height: 149px;border-radius: 10px;">
                            <p style="margin:0;font-size:22px;color: #60C8BD; height: 40px;text-align: center;margin-top:20px;">
                                <img src="../../assets/images/timelength.png" style="display: inline-block;position: relative;top:8px;" />
                                <span style="line-height: 40px;height: 40px;">
                                    辖区工作时长
                                </span>
                            </p>
                            <p style="margin:0;font-size:30px;color: #60C8BD;height: 36px;line-height: 36px;text-align: center;margin-top:20px; ">
                                {{checkinArray.checkin_sum}}小时
                            </p>
                        </el-col>
                    </el-row>
                    <el-row style="margin-top:20px;height: 250px;">
                        <div id="scatter" style="width: 100%;height: 100%">

                        </div>
                    </el-row>

                </el-col>
            </el-row>
        </div>

        <div style="width: 100%;margin-top:10px;flex-wrap: nowrap;display: flex">
            <div style="width: calc(60% - 5px);background: #fff;height: 380px;margin-right: 10px">
                <el-row style="height: 30px;margin-top:10px;float:left;width: 100%;z-index:99">
                    <el-col  style="background: #4BBFEF;height: 30px;width: 15px;">
                    </el-col>
                    <el-col :span="13" style="margin-left: 15px;">
                        <p style="margin:0;line-height: 30px">
                            目标HCP拜访
                        </p>
                    </el-col>
                    <el-col :span="6" style="float: right">
                        <el-button :style="{'background': isCover ? '#FF9901' : '#fff','border': isCover ? '1px solid #FF9901': '1px solid #909399','color': isCover ? '#fff':'#909399','border-radius': '7px'}" size="small" @click="trueCover">正确覆盖</el-button>
                        <el-button :style="{'background': isCover ? '#fff' : '#FF9901','border': isCover ? '1px solid #909399': '1px solid #FF9901','color': isCover ? '#909399':'#fff','width':'80px','border-radius': '7px'}" size="small" @click="cover">覆盖</el-button>
                    </el-col>
                </el-row>
                <el-row>
                    <el-col :span="14" style="height: 350px;">
                        <el-row style="height: 20px;margin-top:30px;margin-left: 10%" id="cover">
                            <el-col :span="4" style="height: 20px;color: #4BBFEF;font-size:16px ">
                                覆盖率
                            </el-col>
                            <el-col :span="1" style="height: 20px;"></el-col>
                            <el-col :span="19" style="height: 20px;">
                                <el-progress :percentage="coverage" style="height: 20px"></el-progress>
                            </el-col>
                        </el-row>
                        <el-row style="height: 275px;margin-left: 10%">
                            <div id="levelCover" style="width: 100%;height: 100%"></div>
                        </el-row>
                    </el-col>
                    <el-col :span="10" style="height: 330px;">
                        <div id="department" style="width: 100%;height: 100%"></div>
                    </el-col>
                </el-row>
            </div>
            <div style="width: calc(40% - 5px);background: #fff;height: 380px;">
                <el-row style="height: 30px;margin-top:10px;float:left;width: 100%;z-index:99">
                    <el-col  style="background: #4BBFEF;height: 30px;width: 15px;">
                    </el-col>
                    <el-col :span="6" style="margin-left: 15px;">
                        <p style="margin:0;line-height: 30px">
                            协访评估对比
                        </p>
                    </el-col>
                    <el-col :span="16" style="float: right;margin-top:-10px;">
                        <div class="block" style="line-height: 52px;margin-right: 10px;float: right">
                            <span class="demonstration" style="font-size: 14px;">协访评估表</span>
                            <el-select v-model="form_id" placeholder="请选择" @change="changeAssessment" >
                                <el-option
                                        v-for="item in assessmentForm"
                                        :key="item.form_id"
                                        :label="item.title"
                                        :value="item.form_id">

                                </el-option>
                            </el-select>
                        </div>
                    </el-col>
                </el-row>
                <el-row style="height: 330px;width: 100%;text-align: center">
                    <div id="radar" style="height: 100%;width: 100%;"></div>
                </el-row>
            </div>
        </div>

        <div style="width: 100%;margin-top:10px;background: #fff;height: 700px;">
            <el-row style="height: 30px;margin-top:10px;float:left;width: 100%;z-index:99">
                <el-col  style="background: #4BBFEF;height: 30px;width: 15px;">
                </el-col>
                <el-col :span="13" style="margin-left: 15px;">
                    <p style="margin:0;line-height: 30px">
                        销售数据
                        <span style="font-size: 12px;color: #C5C1C1">单位：万元</span>
                    </p>
                </el-col>
                <el-col :span="6" style="float: right">
                    <div class="block" style="line-height: 52px;margin-right: 10px;margin-top:-10px;float: right">
                        <span class="demonstration">产品</span>
                        <el-select v-model="product_id" placeholder="请选择" @change="changeTerritoryProduct">
                            <el-option
                                    v-for="item in territoryProductList"
                                    :key="item.product_id"
                                    :label="item.product_name"
                                    :value="item.product_id"
                            >
                            </el-option>
                        </el-select>
                    </div>
                </el-col>
            </el-row>
            <el-row style="height: 300px;">
                <el-col :span="18" style="height: 100%">
                    <div id="subordinates" style="height: 100%;width: 100%"></div>
                </el-col>
                <el-col :span="6" style="height: 100%">
                    <el-row style="width: 100%;height: 150px;padding:20px 20px 0;">
                        <el-col :span="12" style="height: 20px;">
                            指标
                        </el-col>
                        <el-col :span="12" style="height: 20px;text-align: right;">
                            {{totalTarget}}
                        </el-col>
                        <el-col :span="24" class="indicators">
                            <el-progress :percentage="100" style="height: 20px" :show-text="false"></el-progress>
                        </el-col>
                        <el-col :span="12" style="height: 20px;">
                            预估
                        </el-col>
                        <el-col :span="12" style="height: 20px;text-align: right;">
                            {{totalForecastList}}
                        </el-col>
                        <el-col :span="24" class="ins">
                            <el-progress :percentage="rateForecastList" style="height: 20px" :show-text="false"></el-progress>
                        </el-col>
                        <el-col :span="12" style="height: 20px;">
                            销量
                        </el-col>
                        <el-col :span="12" style="height: 20px;text-align: right;">
                            {{totalActualtList}}
                        </el-col>
                        <el-col :span="24" class="dis">
                            <el-progress :percentage="rateActualtList" style="height: 20px" :show-text="false"></el-progress>
                        </el-col>
                    </el-row>
                    <el-row style="width: 100%;height: 100%;padding:20px 20px 0;">
                        <el-col :span="8" style="height: 100%;text-align: center" class="completeR">
                            <el-progress type="circle" :percentage="yieldRate" ></el-progress>
                            <p style="margin:0;font-size:12px;color: #FA541C;text-align: center">达成</p>
                        </el-col>
                        <el-col :span="8" style="height: 100%;text-align: center" class="completeG">
                            <el-progress type="circle" :percentage="sameRate" ></el-progress>
                            <p style="margin:0;font-size:12px;color: #FF9901;text-align: center">同比</p>
                        </el-col>
                        <el-col :span="8" style="height: 100%;text-align: center" class="complete">
                            <el-progress type="circle" :percentage="lastRate" ></el-progress>
                            <p style="margin:0;font-size:12px;color: #60C8BD;text-align: center">环比</p>
                        </el-col>
                    </el-row>
                </el-col>
            </el-row>
            <el-row style="height: 300px;">
                <el-col :span="18" style="height: 100%">
                    <div id="sales" style="height: 100%;width: 100%"></div>
                </el-col>
                <el-col :span="6" style="height: 100%">
                    <el-col :span="24" style="height: 30px;margin-bottom: 5px;">
                        <el-col  style="background: #4BBFEF;height: 20px;width: 5px;">
                        </el-col>
                        <el-col :span="10" style="font-size: 16px;color: #4BBFEF;height: 20px;line-height: 22px;margin-left: 5px">
                            销量排名
                        </el-col>
                    </el-col>
                    <el-col :span="22" v-for="(item,index) in ranking" :key="index" style="border-bottom: 1px solid #DEDEDE;height: 60px;display: flex;flex-wrap: wrap;margin:0 20px;margin-top:5px;">
                        <el-col  style="position: relative;background-color: #F6DE6B;border:none;height: 50px;width:50px;text-align:center;line-height: 50px;border-radius: 50%;font-size: 22px;color: #fff">{{index+1}}
                            <img src="../../assets/images/huangguan.png" style="position: absolute;top:-2px;left:-2px;"/>
                        </el-col>
                        <el-col style="margin-left: 20px;width: 40%;height: 50px;line-height: 50px;font-weight: bold;">
                            {{item.last_name}}
                            <span style="font-size: 14px;color: #C8CCCF;font-weight:normal;">
                            {{item.title}}
                            </span>
                        </el-col>
                        <el-col style="width: 31%;font-size: 14px;margin-top:10px;">
                            <p style="margin:0;">达成率：{{item.yieldRate}}%</p>
                            <p style="margin:0;margin-top:10px;">增长率：{{item.growthRate}}%</p>
                        </el-col>
                    </el-col>
                </el-col>
            </el-row>
        </div>

    </div>

</template>

<script>
    import '../../../node_modules/echarts/map/js/china.js'
    import homepopedom from "./homepopedom";
    import http from "../../APIService/http";
    import {Message} from "element-ui";
    import reportMonth from "../statement/components/reportMonth";
    export default {
        name: "home",
        data(){
            return{
                date:new Date(),
                isCover:true,
                TerritoryList:[],
                form:{
                    territory_id:''
                },
                meeting:'',
                chinaMap:'',
                scatterDom:'',
                levelCover:'',
                department:'',
                subordinates:'',
                radar:'',
                sales:'',
                checkinCount:[],
                visited_hcp:[],
                visit_hcp:[],
                accountObj: {
                    institutions_num: 0,
                    hcp_num: 0,
                    store_num: 0,
                    distributor_num: 0
                },
                customersCoveredObj: {
                    institutions_covered: 0,
                    institutions_type: '',
                    institutions_type_num: 0,
                    hcp_covered: 0,
                    hcp_type: '',
                    hcp_type_num: 0,
                    store_covered: 0,
                    store_type: '',
                    store_type_num: 0,
                    distributor_covered: 0,
                    distributor_type: '',
                    distributor_type_num: 0,
                },
                coachInfo: {
                    coach_plan: 0,
                    plan_num: 0,
                    record_num: 0,
                    plan_completion: 0,
                    unplanned_num:0,
                },
                meettingArray:{
                    meet_sum:0,
                    meet_name:[],
                    meet_list:[],
                },
                checkinArray:{
                    checkin_list:[],
                    checkin_time:'',
                    checkout_time:'',
                    checkin_sum:''
                },
                assessmentForm:[],
                form_id:'',
                assessment_date :[],
                indicator : [],
                indicator_list : [],
                visit_list:[],
                visited_list:[],
                coverage:0,
                territoryProductList:[],
                product_id:'',
                targetList:[],
                actualtList:[],
                oldactualtList:[],
                totalTarget:0,
                totalForecastList:0,
                totalActualtList:0,
                rateForecastList:0,
                rateActualtList:0,
                totalOldActualtList:0,
                totalLastActualtList:0,
                yieldRate:0,
                sameRate:0,
                lastRate:0,
                staffSale:[],
                staffName:[],
                ranking:[]



            }
        },
        created() {
            this.getAssessmentList()
            this.getTerritoryProductList()
        },
        components: {
            homepopedom,
        },
        mounted() {


            window.onresize = () => {
                this.meeting.resize()
                this.chinaMap.resize()
                this.scatterDom.resize()
                this.levelCover.resize()
                this.department.resize()
                this.radar.resize()
                this.subordinates.resize()
                this.sales.resize()
            }


        },
        methods:{
            trueCover(){
                this.isCover = true
                this.getStandardDeptList()
            },
            cover(){
                this.isCover = false
            },
            changeAssessment(){
                this.getAssessmentContrastList()
            },
            // 日期
            changeDate(){
                this.getFirstList()
                this.getStandardDeptList()
                this.getAssessmentContrastList()
                this.getTerritoryProductList()

            },
            // 辖区
            handleSelectInputClick(){
                this.getFirstList()
                this.getStandardDeptList()
                this.getAssessmentContrastList()
                this.getSalesData()
            },
            async getFirstList(){
                let loading = this.$loading({
                    lock: true,
                    text: '拼命加载中',
                    spinner: 'el-icon-loading',
                    background: 'rgba(0, 0, 0, 0.7)'
                });
                try{
                    let data = {
                        user_id: this.$store.getters.getUser.user_id,
                        tenant_id:this.$store.getters.getUser.tenant_id,
                        role:this.$store.getters.getUser.role,
                        month:this.date,
                        territory_id:this.GLOBAL.territory_home_id

                    }
                    await http.post('/wapi/home/getFirstList',data).then(res => {
                        if (res.success) {
                            console.log(res.data)
                            this.accountObj = res.data.accountObj
                            this.customersCoveredObj = res.data.customersCoveredObj
                            this.coachInfo = res.data.coachInfo
                            this.meettingArray = res.data.meettingArray
                            this.checkinArray = res.data.checkinArray
                            this.checkinCount = res.data.checkinCount



                            this.init()
                            loading.close()
                        }
                    })
                }catch (e) {
                    loading.close()
                    Message.error(res.message);
                }


            },
            async getStandardDeptList(){
                try{
                    let data = {
                        user_id: this.$store.getters.getUser.user_id,
                        tenant_id:this.$store.getters.getUser.tenant_id,
                        role:this.$store.getters.getUser.role,
                        month:this.date,
                        territory_id:this.GLOBAL.territory_home_id

                    }
                    await http.post('/wapi/home/getStandardDeptList',data).then(res => {
                            if (res.success) {
                                this.dept_name = res.data.dept_name
                                this.dept_list = res.data.dept_list
                                this.visit_list = res.data.visit_list
                                this.visited_list = res.data.visited_list
                                this.coverage = res.data.coverage
                                this.dept()
                            }
                    })
                }catch (e) {
                    return e
                }
            },
            dept(){
                this.levelCover = this.$echarts.init(document.getElementById('levelCover'));
                this.levelCover.setOption({
                    tooltip: {
                        trigger: 'axis',
                        axisPointer: {            // 坐标轴指示器，坐标轴触发有效
                            type: 'none'        // 默认为直线，可选为：'line' | 'shadow'
                        }
                    },
                    grid: {
                        left: '3%',
                        top:0,
                        bottom: 6,
                        containLabel: true
                    },
                    xAxis: [
                        {
                            type: 'category',
                            data: ['A','B','C','D'],
                            axisLine:{
                                lineStyle:{
                                    color:'#D8D8D8',
                                    // width:2,
                                }
                            },
                            axisLabel: {
                                show: true,
                                textStyle: {
                                    color: '#909399',
                                },
                            }
                        },
                    ],

                    yAxis: [
                        {
                            type: 'value',
                            show:false,
                        }
                    ],
                    series: [
                        {
                            name: '已拜访目标HCP数',
                            type: 'bar',
                            barWidth: 20,
                            stack: '科室',
                            data: this.visited_list,
                            itemStyle:{
                                color:'#81D8D1',
                            }
                        },
                        {
                            name: '未拜访目标HCP数',
                            type: 'bar',
                            barWidth:20,
                            stack: '科室',
                            data: this.visit_list,
                            itemStyle:{
                                color:'#CCEEF1'
                            }
                        },
                    ]
                })
                this.department = this.$echarts.init(document.getElementById('department'));
                this.department.setOption({

                    tooltip: {
                        trigger: 'item',
                        formatter: '{b} : {c}人 ({d}%)'
                    },
                    legend: {
                        left: 'center',
                        top: 'bottom',
                        data: this.dept_name
                    },
                    toolbox: {
                        show: true,
                        feature: {
                            mark: {show: true},

                            magicType: {
                                show: true,
                                type: ['pie']
                            },
                        }
                    },
                    series: [
                        {
                            name: '半径模式',
                            type: 'pie',
                            radius: [20, 110],
                            center: ['50%', '50%'],
                            roseType: 'radius',
                            label: {
                                show: false
                            },
                            emphasis: {
                                label: {
                                    show: true
                                }
                            },
                            data: this.dept_list
                        }

                    ]
                })
            },

            // 协访表
            async getAssessmentList(){
                try {
                    let user = this.$store.getters.getUser
                    let data = {
                        tenant_id:user.tenant_id,
                    }
                    await http.post('/wapi/v1/getAssessmentList',data).then(res=>{
                        if(res.success){
                            this.assessmentForm = res.data
                            if(this.assessmentForm.length>0){
                                this.form_id = res.data[0].form_id
                            }


                        }
                    })
                }  catch (e) {
                    return e
                }
            },
            async getAssessmentContrastList(){
                try{
                    let data = {
                        user_id: this.$store.getters.getUser.user_id,
                        tenant_id:this.$store.getters.getUser.tenant_id,
                        form_id:this.form_id,
                        month:this.date,

                    }
                    await http.post('/wapi/home/getAssessmentContrastList',data).then(res => {
                        if (res.success) {
                            this.assessment_date = res.data.assessment_date
                            this.indicator = res.data.indicator
                            this.indicator_list = res.data.indicator_list
                            this.assessmentContrast()
                        }
                    })
                }catch (e) {
                    return e
                }
            },
            assessmentContrast(){
                this.radar = this.$echarts.init(document.getElementById('radar'));
                this.radar.setOption({
                    tooltip: {},
                    legend: {
                        // data: this.subordinates,
                        data: this.assessment_date,
                        bottom: '-5',
                    },
                    radar: {
                        // shape: 'circle',
                        name: {
                            textStyle: {
                                color: '#fff',
                                backgroundColor: '#999',
                                borderRadius: 3,
                                padding: [3, 5]
                            }
                        },
                        // indicator: this.indicatorMax
                        indicator: this.indicator,
                        center: ['50%', '48%'],
                    },
                    series: [{
                        name: '',
                        type: 'radar',
                        // data: this.contrast
                        data: this.indicator_list
                    }]
                })
            },

            // 产品
            async getTerritoryProductList(){
                try {
                    let user = this.$store.getters.getUser
                    let data = {
                        tenant_id:user.tenant_id,
                        month:this.date,
                        territory_id:this.GLOBAL.territory_home_id
                    }
                    await http.post('/wapi/home/getTerritoryProductList',data).then(res=>{
                        if(res.success){
                            this.territoryProductList = res.data
                            this.product_id = ''
                            if(this.territoryProductList.length>0){
                                this.product_id = this.territoryProductList[0].product_id
                            }
                            this.getSalesData()


                        }
                    })
                }  catch (e) {
                    return e
                }
            },
            changeTerritoryProduct(){
                this.getSalesData()
            },
            async getSalesData(){
                try{
                    let data = {
                        user_id: this.$store.getters.getUser.user_id,
                        tenant_id:this.$store.getters.getUser.tenant_id,
                        product_id:this.product_id,
                        month:this.date,
                        territory_id:this.GLOBAL.territory_home_id
                    }
                    await http.post('/wapi/home/getSalesData',data).then(res => {
                        if (res.success) {
                            console.log(res.data)

                            this.targetList = res.data.target
                            if(res.data.actualt.length>0){
                                this.actualtList = res.data.actualt
                            }else{
                                this.actualtList = res.data.forecast
                            }
                            this.oldactualtList = res.data.oldactualt



                            this.totalTarget = res.data.totalTarget
                            this.totalForecastList = res.data.totalForecastList
                            this.totalActualtList = res.data.totalActualtList
                            this.totalOldActualtList = res.data.totalOldActualtList
                            this.totalLastActualtList = res.data.totalLastActualtList


                            this.rateForecastList = res.data.rateForecastList
                            this.rateActualtList = res.data.rateActualtList

                            if(this.totalTarget>0){
                                this.yieldRate = parseFloat(((this.totalActualtList/this.totalTarget)*100).toFixed(2))
                            }
                            if(this.totalOldActualtList>0){
                                this.sameRate = parseFloat((((this.totalActualtList - this.totalOldActualtList)/this.totalOldActualtList)*100).toFixed(2))
                            }
                            if(this.totalLastActualtList>0){
                                this.lastRate = parseFloat((((this.totalActualtList - this.totalLastActualtList)/this.totalLastActualtList)*100).toFixed(2))
                            }
                            this.staffSale = res.data.staffSale
                            this.staffName = res.data.staffName
                            this.ranking = res.data.ranking





                            this.salesEcharts()
                        }
                    })
                }catch (e) {
                    return e
                }
            },


            salesEcharts(){
                this.subordinates = this.$echarts.init(document.getElementById('subordinates'));
                this.subordinates.setOption({
                    tooltip: {
                        trigger: 'axis',
                        axisPointer: {
                            type: 'cross',
                            crossStyle: {
                                color: '#999'
                            }
                        }
                    },

                    legend: {
                        data: ['指标', '销量/预估', '去年销量'],
                        bottom: '0',
                    },
                    xAxis: [
                        {
                            type: 'category',
                            data: ['1月', '2月', '3月', '4月', '5月', '6月', '7月', '8月', '9月', '10月', '11月', '12月'],
                            axisPointer: {
                                type: 'shadow'
                            }
                        }
                    ],
                    yAxis: {show:false},
                    series: [
                        {
                            name: '指标',
                            type: 'bar',
                            data: this.targetList
                        },
                        {
                            name: '销量/预估',
                            type: 'bar',
                            data: this.actualtList
                        },
                        {
                            name: '去年销量',
                            type: 'line',
                            data: this.oldactualtList
                        },

                    ],
                    color:['#4BBFEF','#60C8BD','#FA541C']
                })
                this.sales = this.$echarts.init(document.getElementById('sales'));
                this.sales.setOption({
                    color: ['#3398DB'],
                    tooltip: {
                        trigger: 'axis',
                        axisPointer: {            // 坐标轴指示器，坐标轴触发有效
                            type: 'shadow'        // 默认为直线，可选为：'line' | 'shadow'
                        }
                    },
                    grid: {
                        left: '3%',
                        right: '4%',
                        bottom: '3%',
                        containLabel: true
                    },
                    xAxis: [
                        {
                            type: 'category',
                            data: this.staffName,
                            axisTick: {
                                alignWithLabel: true
                            }
                        }
                    ],
                    yAxis: [
                        {
                            show: false
                        }
                    ],
                    series: [
                        {
                            name: '销量',
                            type: 'bar',
                            barWidth: '60%',
                            data: this.staffSale
                        }
                    ]
                })
            },
            init(){
                this.meeting=this.$echarts.init(document.getElementById('meeting'));
                this.meeting.setOption({
                    tooltip: {
                        trigger: 'item',
                        formatter: '{a} <br/>{b}: {c} ({d}%)'
                    },
                    legend: {
                        orient: 'vertical',
                        right: 0,
                        top: 60,
                        data: this.meettingArray.meet_name
                    },
                    series: [
                        {
                            name: '会议分布',
                            type: 'pie',
                            radius: ['40%', '55%'],
                            center: ['40%', '50%'],
                            data: this.meettingArray.meet_list
                        }
                    ],
                    // color:["#60C8BD","#FEC34A","#4BBFEF"]
                })
                this.chinaMap=this.$echarts.init(document.getElementById('chinaMap'));
                this.chinaMap.setOption({
                    tooltip: {
                        formatter:function(params,ticket, callback){

                            return params.name+'<br />'+'拜访家数'+'：'+params.value+'家'+'<br />'+'拜访次数'+'：'+params.data.num+'次'
                        }
                    },
                    geo: {
                        map: 'china',
                        roam: false,
                        zoom:1.23,
                        label: {
                            normal: {
                                show: true,
                                fontSize:'10',
                                color: 'rgba(0,0,0,0.7)'
                            }
                        },
                        itemStyle: {
                            normal:{
                                borderColor: 'rgba(0, 0, 0, 0.2)'
                            },
                            emphasis:{
                                areaColor: '#F3B329',
                                shadowOffsetX: 0,
                                shadowOffsetY: 0,
                                shadowBlur: 20,
                                borderWidth: 0,
                                shadowColor: 'rgba(135, 135, 135, 0.2)'
                            }
                        }
                    },
                    series : [
                        {
                            name: '信息量',
                            type: 'map',
                            geoIndex: 0,
                            data:this.checkinArray.checkin_list
                        }
                    ]
                })
                this.scatterDom = this.$echarts.init(document.getElementById('scatter'));
                this.scatterDom.setOption({
                    grid: {
                        top: '10',
                        bottom: '60',
                    },
                    xAxis: {
                        type: 'category',
                        nameGap: 16,
                        nameTextStyle: {
                            color: '#909399',
                            fontSize: 14,

                        },
                        data: ['','8点之前', '9点', '10点', '11点', '12点', '13点', '14点', '15点', '16点', '17点', '18点', '19点及以后',''],
                        splitLine: {
                            show: false
                        },
                        axisLine: {
                            lineStyle: {
                                color: '#E3EEF9',
                                width: 10,
                            }
                        },
                        axisLabel: {
                            show: true,
                            textStyle: {
                                color: '#909399',
                            },
                            interval: 0,
                            rotate: 30,
                            padding: [0, 20]
                        }
                    },
                    array:[],
                    yAxis: {
                        type: 'value',
                        nameLocation: 'end',
                        show: false,
                        nameGap: 20,
                        nameTextStyle: {
                            color: '#fff',
                            fontSize: 16
                        },
                        axisLine: {
                            lineStyle: {
                                color: '#eee'
                            }
                        },
                        splitLine: {
                            show: false
                        }
                    },
                    visualMap: [
                        {
                            dimension: 1,
                            min: 0,
                            max: 100,
                            show: false,
                            textStyle: {
                                color: '#fff'
                            },
                            inRange: {
                                symbolSize: [10, 40],

                            },
                        },
                        {
                            dimension: 2,
                            min: 0,
                            max: 60,
                            show: false,
                            splitNumber: 2,
                            color: ['#ffcc80', '#a5c8f1'],
                            textStyle: {
                                color: '#fff'
                            },

                        }
                    ],
                    series: [
                        {
                            type: 'scatter',
                            data: this.checkinCount,
                            label: {
                                show: true,
                            },
                        },
                    ]
                })




            },

        }
    }
</script>

<style scoped>
    .ins >>> .el-progress-bar__outer{
        background-color:#b8e6f9 ;
    }
    .ins >>> .el-progress-bar__inner{
        background-color:#4BBFEF ;
    }
    .ins >>> .el-progress__text{
        color: #4BBFEF;
    }
    .indicators >>> .el-progress-bar__inner{
        background-color:#b8e6f9 ;
    }
    #cover >>> .el-progress-bar__outer{
        background-color:#b8e6f9 ;
    }
    #cover >>> .el-progress-bar__inner{
        background-color:#4BBFEF ;
    }
    #cover >>> .el-progress__text{
        color: #4BBFEF;
    }
    #hcp >>> .el-progress-bar__outer{
        background-color:#fdbba5 ;
    }
    #hcp >>> .el-progress-bar__inner{
        background-color:#FA541C ;
    }
    #hcp >>> .el-progress__text{
        color: #FA541C;
    }
    #store >>> .el-progress-bar__outer{
        background-color:#ffd79a ;
    }
    #store >>> .el-progress-bar__inner{
        background-color:#FF9901 ;
    }
    #store >>> .el-progress__text{
        color: #FF9901;
    }
    .dis >>> .el-progress-bar__outer{
        background-color:#c0e9e5 ;
    }
    .dis >>> .el-progress-bar__inner{
        background-color:#60C8BD ;
    }
    .dis >>> .el-progress__text{
        color: #60C8BD;
    }

    #plan >>> .el-progress-bar__outer{
        background-color:#ffd79a ;
    }
    #plan >>> .el-progress-bar__inner{
        background-color:#FF9901 ;
    }

    #real >>> .el-progress-bar__outer{
        background-color:#b8e6f9 ;
    }
    #real >>> .el-progress-bar__inner{
        background-color:#4BBFEF ;
    }
    .complete >>> svg path:last-child{
        stroke: #60C8BD;
    }
    .complete >>> .el-progress__text{
             color: #60C8BD;
    }
    .complete >>>.el-progress-circle{
        width: 80px!important;
        height: 80px!important;
    }
    .completeR >>> svg path:last-child{
        stroke: #FA541C;
    }
    .completeR >>> .el-progress__text{
        color: #FA541C;
    }
    .completeR >>>.el-progress-circle{
        width: 80px!important;
        height: 80px!important;
    }
    .completeG >>> svg path:last-child{
        stroke: #FF9901;
    }
    .completeG >>> .el-progress__text{
        color: #FF9901;
    }
    .completeG >>>.el-progress-circle{
        width: 80px!important;
        height: 80px!important;
    }
</style>


// WEBPACK FOOTER //
// src/pages/home/home.vue